import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import View from './view';
import DownloadPreviewZip from './download';

export default class FileUpload extends Component {
    render() {
        const { match } = this.props;
        return (
            <div id="layoutSidenav_content">
                <main>
                    <Switch>
                        <Route path={[`${match.path}/view`]} component={View} />
                        <Route path={[`${match.path}/download-preview-zip`]} component={DownloadPreviewZip} />
                    </Switch>
                </main>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/view/fileuploads/index.js